import { useState } from 'react';
import ModalShell from './ModalShell';
import { useTranslation } from '../../hooks/useTranslation';

const AVAILABLE_ROLES = ['readonly', 'user', 'admin', 'root'];

const RolesModal = ({ user, onClose, onSave }) => {
  const { t } = useTranslation();
  const [selectedRoles, setSelectedRoles] = useState(user.roles || []);

  const toggle = (role) =>
    setSelectedRoles((prev) =>
      prev.includes(role) ? prev.filter((r) => r !== role) : [...prev, role]
    );

  return (
    <ModalShell
      title={t('users.editRolesTitle', { username: user.username })}
      onClose={onClose}
      footer={
        <>
          <button type="button" className="btn btn-secondary" onClick={onClose}>{t('common.cancel')}</button>
          <button type="button" className="btn btn-primary" onClick={() => onSave(selectedRoles)}>{t('common.save')}</button>
        </>
      }
    >
      <div className="modal-body">
        <p>{t('users.selectRolesPrompt')}</p>
        <div className="d-flex flex-wrap gap-3">
          {AVAILABLE_ROLES.map((role) => (
            <div className="form-check" key={role}>
              <input
                className="form-check-input"
                type="checkbox"
                id={`role-${role}`}
                checked={selectedRoles.includes(role)}
                onChange={() => toggle(role)}
              />
              <label className="form-check-label" htmlFor={`role-${role}`}>{role}</label>
            </div>
          ))}
        </div>
      </div>
    </ModalShell>
  );
};

export default RolesModal;
